import React, { useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';

export default function AutoExpandingTextarea({
    value,
    onChange,
    name,
    placeholder,
    disabled,
    isInvalid,
    minRows = 2,
    ...props
}) {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            // Reset height to auto to get the correct scrollHeight
            textareaRef.current.style.height = 'auto';
            // Set new height based on scrollHeight
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [value]);

    return (
        <Form.Control
            ref={textareaRef}
            as="textarea"
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            isInvalid={isInvalid}
            style={{
                minHeight: `${minRows * 1.5}em`, // Adjust based on your line height
                resize: 'none',
                overflow: 'hidden',
                height: 'auto',
            }}
            {...props}
        />
    );
}
